import React from 'react';
import { connect } from 'react-redux';
import { List } from '@mui/material';
import { createActions } from '../../../store';
import CollapsibleSwitchListItem from '../../../../../list-items/CollapsibleSwitchListItem';
import YouTubeCtaPositionListItem from './inputs/YouTubeCtaPositionListItem';

const YouTubeCtaListItem = (props) => {
    const { youTubeCtaEnabled, updateElementsSettings, advanced } = props;

    const onEnabledChange = (value) => updateElementsSettings({ 
        youTubeCta: { enabled: value }
    });
    
    return (
        <CollapsibleSwitchListItem
            checked={youTubeCtaEnabled}
            text='Like & Subscribe Animation'
            onChange={onEnabledChange}
            toolTip={'An animation plays near the start of the video inviting viewers to like and subscribe.'}
            expansionEnabled={advanced}
        >
            <List 
                dense 
                disablePadding
            >
                <YouTubeCtaPositionListItem/>
            </List>
        </CollapsibleSwitchListItem>
    );
};

const mapStateToProps = (state) => {
    const { enabled: youTubeCtaEnabled } = state.createPreview.present.videoSettings.elements.youTubeCta;
    return { youTubeCtaEnabled };
}

const mapDispatchToProps = (dispatch) => {
    const updateElementsSettings = (properties) => dispatch(createActions.updateElementsSettings(properties));
    return { updateElementsSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(YouTubeCtaListItem);